var _defs, _g, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTypeDespaces(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Calque_1",
    "data-name": "Calque 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 261.31 170.71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.4;}.cls-2{fill:#d61983;}.cls-3{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:3px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-678.55,411.53V381.12s-80.87,19.34-107.83,19.34c-26.24,0-104.91-19.34-104.91-19.34v30.41s78.67,19.34,104.91,19.34C-759.42,430.87-678.55,411.53-678.55,411.53Z",
    transform: "translate(916.06 -381.12)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M-678,505.36c-.2,0-.37.06-.57.06v-1.3l-98.59-74.28h-15.53l-93.06,76.7a22.57,22.57,0,0,0-7.09-1.18,23.25,23.25,0,0,0-23.24,23.24,23.21,23.21,0,0,0,23.24,23.23,23.24,23.24,0,0,0,22.67-18.25l86-72.08L-701,525.44c-.11,1.09-.22,2.13-.22,3.16A23.21,23.21,0,0,0-678,551.83a23.24,23.24,0,0,0,23.23-23.23A23.28,23.28,0,0,0-678,505.36Z",
    transform: "translate(916.06 -381.12)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M-710.36,440.61V419.16s-57.06,13.64-76.07,13.64c-18.51,0-74-13.64-74-13.64v21.45s55.51,13.65,74,13.65C-767.42,454.26-710.36,440.61-710.36,440.61Z",
    transform: "translate(916.06 -381.12)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M-710,506.81c-.14,0-.26,0-.4,0v-.92l-69.56-52.4h-11l-65.66,54.11a15.93,15.93,0,0,0-5-.83,16.39,16.39,0,0,0-16.39,16.4,16.37,16.37,0,0,0,16.39,16.39,16.39,16.39,0,0,0,16-12.88l60.68-50.85L-726.2,521a21.41,21.41,0,0,0-.15,2.23A16.37,16.37,0,0,0-710,539.6a16.4,16.4,0,0,0,16.39-16.39A16.42,16.42,0,0,0-710,506.81Z",
    transform: "translate(916.06 -381.12)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTypeDespaces);
export default __webpack_public_path__ + "static/media/type-despaces.270641375aaf54d9c526b44aea7a6550.svg";
export { ForwardRef as ReactComponent };